import React, { useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import Input from "../../../../../stories/Input/Input";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import { Keys, SpecialKeys } from "../../../../../utils/Enum.keys";
import {
  CustomModal,
  handleMUISelectEvent,
} from "../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import Edit from "../../../../../images/Edit.svg";
import Delete from "../../../../../images/Delete.svg";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import AddSEwithoutPE from "./Add/Add";
import { LicenseTypes, PageFor } from "../../../../../utils/Enum.types";
import { TableStockEntryItem } from "../../../../../utils/formTypes";
import { useHotKey } from "../../../../../utils/hotKeys";
import Navbar from "../../../../common/layout/Navbar";

const groupOptions = ["IT Equipment", "Tools and Machinery", "Softwares"];
const Data = [
  {
    code: "Code1",
    description: "CCTV Camera",
    group: "Camera",
    category: "equipment",
    sub_catg: "Laptop",
    ref_no: "Acer-220",
    uom: "No's",
    ob: "-",
  },
];

const SEWithoutPurchaseEntry = () => {
  const navigate = useNavigate();
  const { Purchase } = useAssetTableJson();
  const { customer_id } = useUrlParams();
  const [viewModal, setViewModal] = useState(false);

  const [formData, setFormData] = useState<TableStockEntryItem>({
    slNo: "",
    serialNo: "",
    batch: "",
    expiry: "",
    warrantyStartDate: "",
    warrantyEndDate: "",
    maintainedBy: "",
    amcEnabled: false,
    amcStartDate: "",
    amcEndDate: "",
    geoLocation: "",
    insuranceStartDate: "",
    insuranceEndDate: "",
    stockLocation: "",
  });

  useHotKey({
    handleFunc: () => {
      navigate(
        `/assets/purchase/${customer_id}/stockentry/withoutpurchaseentry/add`
      );
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });
  const dynamicHeaders: TableHeaderProps[] =
    Purchase.StockEntry.withoutPurchaseEntry.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <img src={Edit} alt="" />
              <img src={Delete} alt="" />
            </>
          );
        }

        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        code: data.code,
        description: data.description,
        group: data.group,
        category: data.category,
        sub_catg: data.sub_catg,
        ref_no: data.ref_no,
        uom: data.uom,
        ob: data.ob,
      };
    }) || [];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.STOCK_ENTRY_WITHOUT_PURCHASE_ENTRY
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.STOCK_ENTRY_WITHOUT_PURCHASE_ENTRY,
      JSON.stringify(newModel)
    );
  };
  return (
    <>
      <Navbar NavType={LicenseTypes.SUBSIDIARY} />
      <Title>Stock Entry Without Purchase Entry</Title>
      <div className="stock-entry">
        <div className="stock-entry__select row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Sub-Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Manufacturer"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="HSN"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col flex-end">
            <Button
              mode="addnew"
              autoFocus
              onClick={() =>
                navigate(
                  `/assets/purchase/${customer_id}/stockentry/withoutpurchaseentry/add`
                )
              }
            />
          </div>
        </div>
        <div className="stock-entry__tableblock">
          {Data.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onCellClick={(params) => {
                if (params.field === "ref_no") {
                  setViewModal(!viewModal);
                }
              }}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <Button mode="export" />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>

      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(!viewModal)}
        contentComponent={
          <AddSEwithoutPE
            setModalFlag={setViewModal}
            pageType={PageFor.MODAL}
          />
        }
        style={ViewModalStyles}
      />
    </>
  );
};

export default SEWithoutPurchaseEntry;
